<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.the-steps-section
    t-section
      //- t-h2 5 КРОКІВ ДЛЯ АНТИКОРУПЦІЙНИХ ЗМІН
      //- t-h3 послідовність згідно рейтингу 2017 року

      +e.steps
        +e.step
          +e.a.link(href="static/download/Рекомендації-на-2018-рік.pdf")
            +e.IMG.img(src="static/img/image-1.png")
        +e.step
          +e.a.link(href="static/download/Презентація-результатів-CPI-2017.pdf")
            +e.IMG.img(src="static/img/image-2.png")
        +e.step
          +e.a.link(href="static/download/Рекомендації-2017-та-стан-їх-виконання.pdf")
            +e.IMG.img(src="static/img/image-3.png")
        +e.step
          +e.a.link(href="static/download/Що-таке-CPI.pdf")
            +e.IMG.img(src="static/img/image-4.png")


</template>

<script>
import TSection from '@/components/TSection/TSection';
import TH2 from '@/components/TH2/TH2';
import TH3 from '@/components/TH3/TH3';

export default {
  name: 'the-steps-section',

  data() {
    return {

    };
  },

  components: {
    TSection,
    TH2,
    TH3,
  },
};
</script>


<style lang="scss">
@import '../../scss/styles';

.the-steps-section {
  position: relative;
  width: 100%;
  overflow: auto;

  &__img {
    width: 100%;
    background-color:$color-bg;
  }

  &__steps {
    display: flex;
    margin-top: 48px;
    margin-bottom: 48px;
    overflow: auto;
  }

  &__step {
    width: calc(25% - 16px);
    color: $color-white;
    font-size: 12px;
    font-weight: 600;
    padding: 8px;
    opacity: 1;
    transform: scale(1);
    transition: all 0.3s;

    &:hover {
      transform: scale(0.9);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheStepsSection/TheStepsSection.vue